import type { ReactNode } from 'react';
import { Header } from './Header';

interface PageContainerProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
}

export function PageContainer({
  title,
  subtitle,
  action,
  children,
}: PageContainerProps) {
  return (
    <div className="min-h-screen">
      <Header title={title} subtitle={subtitle} action={action} />
      <main className="p-6">{children}</main>
    </div>
  );
}
